import { ISelectType, useFetch, useFormContext } from "@4uhub/lib4uhub";
import { useCallback, useEffect, useState } from "react";
import { useWatch } from "react-hook-form";
import { ticketChannelStep } from "../../../../../../../services/ticketChannelStep.service";
import { TTicketAutoTransferRuleForm } from "../TicketAutoTransferRuleSchema";
import { IParamsTicketChannelStepsAll } from "../../../../../../../models/ticket-channel-step";

export const useTicketChannelSteps = (
  fieldName: "ticketChannel" | "ticketChannelTransfer",
  params?: Partial<Omit<IParamsTicketChannelStepsAll, "id">>
) => {
  const { control } = useFormContext<TTicketAutoTransferRuleForm>();
  const [ticketChannelSteps, setTicketChannelSteps] = useState<ISelectType[]>(
    []
  );
  const { sendRequest } = useFetch(ticketChannelStep);

  const ticketChannel = useWatch({
    name: fieldName,
    control,
  });

  const fetchTicketChannelSteps = useCallback(async () => {
    if (!ticketChannel?.id) {
      setTicketChannelSteps([]);
      return;
    }
    const { data, success } = await sendRequest({
      ...params,
      id: ticketChannel.id,
    });
    if (data && success) {
      setTicketChannelSteps(data);
    }
  }, [sendRequest, ticketChannel]);

  useEffect(() => {
    fetchTicketChannelSteps();
  }, [fetchTicketChannelSteps, ticketChannel]);

  return { ticketChannelSteps };
};
